/* tslint:disable */
/* eslint-disable */
/**
 * driverPortal fleet-registration api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */
import type { DriverRegistrationLogLastStep } from './DriverRegistrationLogLastStep';
import type { DriverRegistrationLogFlowType } from './DriverRegistrationLogFlowType';
import type { BrandEnum } from './BrandEnum';
import type { DriverRegistrationLogStatus } from './DriverRegistrationLogStatus';
import type { DriverRegistrationLogType } from './DriverRegistrationLogType';
import type { DriverRegistrationLogCreatedVia } from './DriverRegistrationLogCreatedVia';
import type { DriverRegistrationLogSource } from './DriverRegistrationLogSource';
import type { DriverRegistrationLogLicenseTypeSelection } from './DriverRegistrationLogLicenseTypeSelection';

export interface DriverRegistrationLogResponse {
    id: number;
    /** min length: 40, max length: 40 */
    hash: string;
    last_step: DriverRegistrationLogLastStep;
    driver_root_id: number | null;
    /** max length: 2147483647 */
    email: string | null;
    phone: string | null;
    username: string | null;
    first_name: string | null;
    last_name: string | null;
    personal_code: string | null;
    company_id: number | null;
    country: string | null;
    city_id: number | null;
    language: string | null;
    referral_code: string | null;
    has_car: number | null;
    car_model_id: number | null;
    car_color: string | null;
    car_transport_licence_number: string | null;
    model: string | null;
    year: number | null;
    seats: number | null;
    vin: string | null;
    license_plate: string | null;
    display_name: string | null;
    driver_license: string | null;
    has_taxi_license: number | null;
    taxi_license: string | null;
    type: DriverRegistrationLogType | null;
    license_type_selection: DriverRegistrationLogLicenseTypeSelection | null;
    company_name: string | null;
    address: string | null;
    reg_code: string | null;
    beneficiary_name: string | null;
    iban: string | null;
    swift: string | null;
    data: string | null;
    status: DriverRegistrationLogStatus;
    source: DriverRegistrationLogSource;
    birthday: string | null;
    remote_training_url: string | null;
    flow_id: number | null;
    allow_fleet_matching: number | null;
    brand: BrandEnum;
    flow_type: DriverRegistrationLogFlowType;
    app_version: string | null;
    created_via: DriverRegistrationLogCreatedVia | null;
    city: string | null;
}
